// app/javascript/controllers/confirmation_code_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["input", "timer", "resendBtn"];

  connect() {
    this.startTimer();
    this.updateTimerDisplay(5 * 60); // 5 minutes in seconds
  }

  format(event) {
    let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    // Add hyphen after 3 characters
    if (value.length > 3) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6);
    }

    event.target.value = value;
  }

  autoSubmit(event) {
    // Auto-submit when 7 characters (including hyphen) are entered
    if (event.target.value.length === 7) {
      event.target.closest('form').submit();
    }
  }

  startTimer() {
    const expiresAt = localStorage.getItem('confirmation_expires_at');

    if (expiresAt) {
      this.updateTimer(parseInt(expiresAt));
      this.timerInterval = setInterval(() => this.updateTimer(parseInt(expiresAt)), 1000);
    }
  }

  updateTimer(expiresAt) {
    const now = Math.floor(Date.now() / 1000);
    const remaining = expiresAt - now;

    if (remaining <= 0) {
      this.updateTimerDisplay(0);
      this.disableInput();
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      return;
    }

    this.updateTimerDisplay(remaining);
  }

  updateTimerDisplay(seconds) {
    if (this.hasTimerTarget) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      this.timerTarget.textContent = `Noch ${minutes}:${secs.toString().padStart(2, '0')} Minuten`;
    }
  }

  disableInput() {
    if (this.hasInputTarget) {
      this.inputTarget.disabled = true;
      this.inputTarget.placeholder = "Code abgelaufen";
    }
  }

  disconnect() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
